import HeroSection from "@/components/home/hero-section";
import CompanyOverview from "@/components/home/company-overview";
import ServiceCards from "@/components/home/service-cards";
import Register from "@/components/home/register";
import QuoteForm from "@/components/home/quote-form";
import TeamSection from "@/components/home/team-section";
import TestimonialsSection from "@/components/home/testimonials-section";
import ContactSection from "@/components/home/contact-section";

const Home = () => {
    return (
        <>
            <HeroSection />
            <ServiceCards />
            <Register />
            <CompanyOverview />
            <Register />
        </>
    );
};

export default Home;
